import React from 'react'
import { omit, set, noop } from 'lodash'
import { connect } from 'react-redux'

import FlatButton from 'material-ui/FlatButton'
import RaisedButton from 'material-ui/RaisedButton'
import DeleteIcon from 'material-ui/svg-icons/action/delete'
import Dialog from 'material-ui/Dialog'

import api from '../../api'
import Fields from './fields'
import attachFiles from './attach-files'
import { setSnackbarMessage } from '../../actions/snackbar'

const styles = {
  form: {
    maxWidth: 500
  }
}

class Edit extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      pageBlock: props.pageBlock,
      files: {}
    }
  }

  render () {
    return (
      <div>
        <form onSubmit={this.handleSubmit.bind(this)} style={styles.form}>
          <div>
            <Fields
              fields={this.props.blockType.fields}
              schema={this.props.blockType.schema}
              content={this.state.pageBlock.block_content}
              files={this.state.files}
              handleValueChange={this.handleBlockContentValueChange.bind(this)}
              handleFileChange={this.handleBlockContentFileChange.bind(this)}
            />
          </div>

          <RaisedButton
            label='Save'
            primary
            onClick={this.handleSubmit.bind(this)}
          />

          <FlatButton
            label='Delete Block'
            secondary
            onClick={this.handleDelete.bind(this)}
            icon={<DeleteIcon />}
          />
        </form>
        <Dialog
          title='Error'
          modal={false}
          open={!!this.state.error}
          actions={[
            <FlatButton
              label='OK'
              primary
              onClick={this.handleAcknowledgeErrorMessage.bind(this)}
            />
          ]}
          onRequestClose={this.handleAcknowledgeErrorMessage.bind(this)}
        >
          {this.state.error}
        </Dialog>
      </div>
    )
  }

  handleSubmit (e) {
    e.preventDefault()

    const body = omit(this.state.pageBlock, 'id')

    api.patch(`admin/${this.props.target}/${this.state.pageBlock.id}`, { body })
      .then(res => {
        if (res.status === 200) {
          res.json()
            .then(this.attachFiles.bind(this))
            .then(data => {
              this.props.setSnackbarMessage(`Successfully updated #${data.id}`)
              this.props.onBlockUpdated(data)
            })
        } else if (res.status === 400) {
          res.json()
            .then(data => {
              this.setState({ error: data.message })
              this.props.setSnackbarMessage('Block could not be updated')
            })
        } else {
          res.json()
            .then(data => {
              this.setState({ error: data.message })
              this.props.setSnackbarMessage('Unhandled error')
            })
        }
      })
  }

  attachFiles (pageBlock) {
    if (Object.keys(this.state.files).length === 0) {
      return Promise.resolve(pageBlock)
    }
    return attachFiles(pageBlock, this.props.target, this.state.files)
  }

  handleDelete (e) {
    e.preventDefault()

    api.del(`admin/${this.props.target}/${this.state.pageBlock.id}`)
      .then(res => res.json())
      .then(data => {
        this.props.setSnackbarMessage(`Successfully deleted #${this.state.pageBlock.id}`)
        this.props.onBlockDeleted(data)
      })
  }

  handleBlockContentValueChange (field, value) {
    this.props.onDirty()
    this.setState(prevState => {
      const blockContent = {
        ...prevState.pageBlock.block_content,
        [field.prop]: value
      }

      return {
        ...prevState,
        pageBlock: {
          ...prevState.pageBlock,
          block_content: blockContent
        }
      }
    })
  }

  handleBlockContentFileChange (propPath, formData, file) {
    this.props.onDirty()
    this.setState(prevState => {
      const files = { ...prevState.files }
      set(files, propPath, { formData, file })
      return { ...prevState, files }
    })
  }

  handleAcknowledgeErrorMessage () {
    this.setState({ error: null })
  }
}

// @ts-ignore
Edit.propTypes = {
  target: React.PropTypes.string.isRequired,
  pageBlock: React.PropTypes.object.isRequired,
  blockType: React.PropTypes.object.isRequired,
  onBlockUpdated: React.PropTypes.func.isRequired,
  onBlockDeleted: React.PropTypes.func.isRequired,
  setSnackbarMessage: React.PropTypes.func.isRequired,
  onDirty: React.PropTypes.func
}

// @ts-ignore
Edit.defaultProps = {
  pageBlock: {},
  onDirty: noop
}

export default connect(null, { setSnackbarMessage })(Edit as any) as React.ComponentType<any>
